<template>
  <div v-show='data.hidden === false' class="col-sm-12 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      {{data.showName}}
    </div>
    <div>
      <ejs-radiobutton v-for="(option) in this.data.options" cssClass="h-subscriber-radioCommonStyle" ref="radioButton" :label='option.showName' :name='data.name' :checked='data.value === option.value' :value='option.value' @change="caculateRadioButton"/>
    </div>
    <!--<button @click="getData">GetParam</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_CheckBox',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
      classText: 'h-subscriber-input',
    };
  },
  methods: {
    caculateRadioButton(event) {
      this.params.paramVal = event.value;
      try {
        if (this.changeFunc !== undefined) {
          this.changeFunc();
        }
      } catch (e) {
        ;
      }
      this.$refs.radioButton.forEach((item, index) => {
        if (item.ej2Instances.checked === true) {
          this.params.paramVal = this.data.options[index].value;
        }
      });
    },
  },
  created() {
    this.$parseInitData();
  }
};
</script>

<style scoped>

</style>
